import React from 'react'
import { Grid, makeStyles, SvgIcon, Typography } from '@material-ui/core';
import { ReactComponent as AmbulanciaIcon } from './../../../assets/icons/iconoAmbulancia.svg';
import { ReactComponent as CallCenterOutlinedIcon } from './../../../assets/icons/iconoCallCenter2.svg';
import { ReactComponent as WhatsAppIcon } from './../../../assets/icons/iconoWhatsapp.svg';
import { ReactComponent as FaqsIcon } from './../../../assets/icons/iconoFaqs.svg';

const useStyles = makeStyles((theme) => ({
    footer: {
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        paddingBottom: "1rem"
    },
    centerItems: {
        textAlign: "center",
        marginBottom: "1rem"
    },
    textBold: {
        fontWeight: "bold"
    }
}));
const FooterAfiliado = () => {

    const classes = useStyles()
    return (
        <footer className={classes.footer}>
            <Grid container style={{ paddingRight: "4rem", paddingLeft: "4rem" }}>

                <Grid item xs={12} sm={6} md={3} className={classes.centerItems} >
                    <SvgIcon fontSize="large"><AmbulanciaIcon /></SvgIcon>
                    <Typography color="secondary">URGENCIAS Y EMERGENCIAS</Typography>
                    <Typography color="secondary" className={classes.textBold}>08003456773</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.centerItems}>
                    <SvgIcon fontSize="large"><CallCenterOutlinedIcon /></SvgIcon>
                    <Typography color="secondary">ATENCIÓN AL BENEFICIARIO</Typography>
                    <Typography color="secondary" className={classes.textBold}>08003456773</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.centerItems}>
                    <SvgIcon fontSize="large"><WhatsAppIcon /></SvgIcon>
                    <Typography color="secondary" className={classes.textBold}>WHATSAPP</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.centerItems}>
                    <SvgIcon fontSize="large"><FaqsIcon /></SvgIcon>
                    <Typography color="secondary" className={classes.textBold}>PREGUNTAS FRECUENTES</Typography>
                </Grid>
            </Grid>
        </footer>
    )
}

export default FooterAfiliado
